import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import { Button, colors, media } from '@material-dev/thread';
import Cropper from 'react-cropper';

// Add CSS file per react-cropper instructions
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';

import BaseFooter from 'admin/components/Modal/Footer';
import { Modal } from 'admin/components/Modal';
import ModalToolbar from 'admin/components/ModalToolbar';
import { PageTitle } from 'admin/components/Typography';

const Wrapper = styled(Flex).attrs({
  flexDirection: 'column'
})`
  background-color: ${colors.black10};
  max-height: 90vh;
  ${media.md`
    min-width: 900px;
  `}
`;

const Menu = styled(Flex)`
  list-style: none;
  li {
    margin: 8px;
  }
  li:hover {
    cursor: pointer;
  }
`;

const CenteredMenu = styled(Menu)`
  margin: 0 auto;
`;

const Footer = styled(BaseFooter)`
  border-top: 1px solid #ddd;
  background: #fff;
  min-height: 64px;
`;

const SecondaryButton = styled(Button).attrs({
  large: true
})`
  color: ${colors.darkGray};
  width: 100%;
  margin: 0;

  ${media.sm`
    margin-right: 20px;
    width: auto;
  `}

  * {
    /* prevent incorrect gtm triggering on button children */
    pointer-events: none;
  }
`;

const PrimaryButton = styled(SecondaryButton).attrs({
  variant: 'primary'
})`
  box-shadow: none;

  &:hover {
    background-color: ${colors.black54};
  }

  &:disabled {
    background-color: ${colors.black38};
  }

  &:hover:disabled {
    cursor: not-allowed;
  }
`;


export class ImageEditor extends Component {
  constructor(props) {
    super(props);
    this.imageDimension = '350px';

    this.state = { editedCanvas: null };
  }

  componentDidMount() {
    if (this.cropper) {
      this.setState({
        editedCanvas: this.cropper.getCroppedCanvas()
      });
    }
  }

  componentWillUnmount() {
    this.reset();
  }

  reset = () => {
    this.setState({ editedCanvas: null });
  }

  setCropperRef = (cropper) => {
    this.cropper = cropper;
  }

  crop = () => {
    this.setState({ editedCanvas: this.cropper.getCroppedCanvas() });
  }

  rotate = () => {
    this.cropper.enable();
    this.cropper.clear();
    this.cropper.rotate(-90);
    this.setState({ editedCanvas: this.cropper.getCroppedCanvas() });
  }

  handleSave = () => {
    const { onSave, imageIndex } = this.props;
    const { editedCanvas } = this.state;

    if (editedCanvas) {
      editedCanvas.toBlob((blob) => {
        onSave(blob, imageIndex);
        this.reset();
      });
    }
  }

  handleClose = () => {
    this.reset();
    this.props.onClose();
  }

  render() {
    const { id, isOpen, onClose, url } = this.props;

    return (
      <Modal open={isOpen}>
        <Wrapper>
          <ModalToolbar bgColor='#0FB3CC' height='64px'>
            <PageTitle>Image Editor</PageTitle>
            <Button
              variant='icon'
              icon='close'
              onClick={onClose}
            />
          </ModalToolbar>
          <ModalToolbar bgColor='#0DA1B7' height='48px'>
            <CenteredMenu>
              <Button
                variant='link'
                icon='crop'
                onClick={this.crop}>
                Crop
              </Button>
              <Button
                variant='link'
                icon='rotate_90_degrees_ccw'
                onClick={this.rotate}>
                Rotate
              </Button>
            </CenteredMenu>
          </ModalToolbar>
          <Box width={['100%', 'auto']} pb={['8px', 0]}>
            <Flex justifyContent={['space-between', 'center']} pt={15} pb={15}>
              <Cropper
                background={false}
                crop={this.crop}
                id={`img-${id}`}
                ref={this.setCropperRef}
                src={url}
                style={{ width: this.imageDimension, height: this.imageDimension }}
                // Does not allow the cropbox to exceed the size of the image container
                viewMode={2}
              />
            </Flex>
          </Box>
          <Footer>
            <SecondaryButton
              onClick={this.handleClose}>
                    Cancel
            </SecondaryButton>
            <PrimaryButton
              onClick={this.handleSave}
              disabled={!this.state.editedCanvas}>
                    Save New Image
            </PrimaryButton>
          </Footer>
        </Wrapper>
      </Modal>
    );
  }
}

ImageEditor.propTypes = {
  id: PropTypes.string,
  imageIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  url: PropTypes.string
};

export default ImageEditor;



// WEBPACK FOOTER //
// ./src/app/admin/components/ImageEditor/index.js